
import React from "react";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col
} from "reactstrap";

// core components
import SimpleHeader from "../../../../components/Headers/SimpleHeader";
import connect from 'redux-connect-decorator';
import { randomWord } from '../../../../actions/glossaryActions';
import VoicePlayer from '../../components/VoicePlayer';

@connect(
  state => ({
    word: state.word.word,
    loading: state.word.loading
  }),
  {
    randomWord
  }
)
class Home extends React.Component<any, any> {
  componentDidMount() {
    this.props.randomWord();
  }

  componentWillMount() {
  }

  render() {
    const { word } = this.props;
    return (
      <>
        <SimpleHeader name="Home" parentName="Dashboards" />
        <Container className="mt--6" fluid>
          <Row className="justify-content-center">
            <Col className="card-wrapper ct-example" lg="8">
              <Card>
                <CardHeader>
                  <h3 className="mb-0">Word daily</h3>
                </CardHeader>
                <CardBody>
                  <div className="pt-1 text-center">
                    <h3>{word.topic}</h3>
                    <h5>{word.english} { word.english && <VoicePlayer text={ word.english } />}</h5>
                    <h5>{word.vietnamese}</h5>
                    <div>
                        <small>{word.pronunciation}</small>
                    </div>
                    { word.usage && <div>
                        <blockquote>{word.usage}</blockquote>
                    </div>}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </>
    );
  }
}

export default Home;
